import type { FluxErrorEntityErrorCodes } from '../types.js';

export const BulkActionsErrorCodes = {
  BulkActionAlreadyDispatched: {
    code: 'bulk-action/already-dispatched',
    message: 'Esta ação em massa já foi enviada para processamento.',
    explanation: 'Esta ação em massa já foi enviada para processamento e não pode ser reenviada. Ações em massa só podem ser processadas uma vez.',
    localizations: {},
  },
  BulkActionDownloadFailed: {
    code: 'bulk-action/download-failed',
    message: 'Não foi possível baixar o arquivo informado para executar a ação em massa.',
    explanation: 'Não foi possível executar a ação em massa pois o arquivo informado não pôde ser baixado. Isso pode ocorrer por diversos motivos, como problemas internos ou o arquivo não estar mais disponível.',
    localizations: {},
  },
  BulkActionInvalidActionType: {
    code: 'bulk-action/invalid-action-type',
    message: 'O tipo de ação em massa informado é inválido.',
    explanation: 'O tipo de ação em massa fornecido é inválido. Verifique se o tipo está correto e tente novamente.',
    localizations: {},
  },
  BulkActionMissingEntityId: {
    code: 'bulk-action/missing-entity-id',
    message: 'O ID da entidade necessária para executar a ação em massa está faltando.',
    explanation: 'O ID da entidade necessária para executar a ação em massa está faltando. Cada tipo de ação requer um ID de uma entidade específica.',
    localizations: {},
  },
  BulkActionMissingInputFile: {
    code: 'bulk-action/missing-input-file',
    message: 'O arquivo de entrada necessário para executar a ação em massa está faltando.',
    explanation: 'O arquivo de entrada necessário para executar a ação em massa está faltando. Verifique se o arquivo foi fornecido corretamente.',
    localizations: {},
  },
  BulkActionNotCreator: {
    code: 'bulk-action/not-creator',
    message: 'Apenas o criador da ação em massa pode interagir.',
    explanation: 'Apenas o criador da ação em massa pode interagir com a ação. Caso necessário, crie uma nova ação em massa.',
    localizations: {},
  },
  BulkActionNotFound: {
    code: 'bulk-action/not-found',
    message: 'Ação em massa não encontrada.',
    explanation: 'A ação em massa que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
  BulkActionUnsupportedFileType: {
    code: 'bulk-action/unsupported-file-type',
    message: 'O tipo de arquivo fornecido não é suportado para esta ação em massa.',
    explanation: 'O tipo de arquivo fornecido para a ação em massa não é suportado. A ação em massa suporta aquivos nos formatos CSV, XLSX e JSON.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'bulk-action'>;
